var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form-item",
        {
          ref: "formItem",
          class: { elitem: _vm.$attrs.width && _vm.$attrs.width == "full" },
          style: _vm.$attrs["style"],
          attrs: {
            "label-width": _vm.$attrs["label-width"],
            prop: _vm.$attrs["prop"],
            label: _vm.$attrs["label"],
          },
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 0 } },
            [
              _c(
                "el-col",
                {
                  staticClass: "col_positon",
                  attrs: { span: !_vm.single ? 8 : 24 },
                },
                [
                  _c("el-input", {
                    staticClass: "left_input",
                    class: { leftInput: _vm.single },
                    attrs: { disabled: _vm.more || _vm.disable },
                    model: {
                      value: _vm.code,
                      callback: function ($$v) {
                        _vm.code = $$v
                      },
                      expression: "code",
                    },
                  }),
                  _c(
                    "div",
                    {
                      staticClass: "more_box flex_center flex_center_align",
                      on: { click: _vm.openMode },
                    },
                    [
                      _vm.more
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "inner_box flex_center flex_center_align",
                            },
                            [
                              _c("svg-icon", {
                                attrs: { "icon-class": "sel" },
                              }),
                            ],
                            1
                          )
                        : _c("svg-icon", { attrs: { "icon-class": "select" } }),
                    ],
                    1
                  ),
                ],
                1
              ),
              !_vm.single
                ? _c(
                    "el-col",
                    { attrs: { span: 16 } },
                    [
                      _vm.cname == "building" && !_vm.showDetailBtn
                        ? _c("vab-select", {
                            staticClass: "right_input",
                            attrs: {
                              prop: "dong",
                              "data-key": "dongconst",
                              "label-id": "label",
                              "value-id": "value",
                              "data-type": "local",
                              placeholder: "",
                              clearable: "",
                            },
                          })
                        : _c("el-input", {
                            staticClass: "right_input",
                            attrs: { disabled: _vm.disable },
                            model: {
                              value: _vm.name,
                              callback: function ($$v) {
                                _vm.name = $$v
                              },
                              expression: "name",
                            },
                          }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-col",
                { attrs: { span: 1 } },
                [
                  _c(
                    "el-popover",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showDetailBtn,
                          expression: "showDetailBtn",
                        },
                      ],
                      attrs: { placement: "bottom", trigger: "click" },
                    },
                    [
                      _c(
                        "el-table",
                        { attrs: { data: _vm.list, border: "", stripe: "" } },
                        [
                          _c("el-table-column", {
                            attrs: {
                              width: "80",
                              property: "blgscd",
                              label: "建物CD",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              width: "120",
                              property: "blgsnmkj",
                              label: "建物名",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "more_box flex_center flex_center_align",
                          attrs: { slot: "reference" },
                          slot: "reference",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "inner_box flex_center flex_center_align",
                            },
                            [
                              _c("svg-icon", {
                                attrs: { "icon-class": "sel" },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        _vm.cname,
        _vm._b(
          {
            ref: _vm.cname,
            tag: "component",
            on: { save: _vm.handleSureSelect },
          },
          "component",
          _vm.$attrs,
          false
        )
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }